import { Button } from '@main/ad-core-components';
import { SUPPORT_CONTACT } from '@main/admin-dashboard/src/args';
import { Badge, Icon, LoadingSpinner, useRedirect } from '@main/core-ui';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useTheme } from 'styled-components';

import { useIntercomLoaded } from './hooks';
import { navMenuMessages } from './NavMenu/messages';

export const IntercomButton: React.FC = () => {
  const { intercomLoaded, intercomFailed } = useIntercomLoaded();
  const redirect = useRedirect();
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const [unreadCount, setUnreadCount] = useState(0);

  const intercomDoneLoadingOrFailed = intercomLoaded || intercomFailed;

  useEffect(() => {
    if (intercomLoaded && !intercomFailed) {
      // Subscribe to count changes
      Intercom('onUnreadCountChange', (count) => {
        setUnreadCount(count);
      });
    }
  }, [intercomLoaded, intercomFailed]);

  return (
    <Button
      onClick={() => {
        if (intercomLoaded) {
          Intercom('show');
        }
        if (intercomFailed) {
          redirect(`mailto:${SUPPORT_CONTACT}`);
        }
      }}
      disabled={!intercomDoneLoadingOrFailed}
      variant="link"
      style={{
        maxWidth: '100%',
        backgroundColor: theme.colors.transcend4,
        borderRadius: '5em',
        padding: 3,
      }}
    >
      {intercomDoneLoadingOrFailed ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
          }}
        >
          <span
            style={{
              flexShrink: 0,
              display: 'flex',
              alignItems: 'center',
              paddingLeft: 3,
            }}
          >
            <Icon
              type="chat-conversation-question"
              color={theme.colors.transcend}
              size={18}
            />
          </span>
          <span
            style={{
              marginLeft: '0.5em',
              marginRight: '0.5em',
              color: theme.colors.transcend,
              whiteSpace: 'nowrap',
            }}
          >
            {formatMessage(navMenuMessages.contactSupport)}
          </span>
          <Badge round>{unreadCount}</Badge>
        </div>
      ) : (
        <LoadingSpinner small />
      )}
    </Button>
  );
};
